const EXACT_PUBLIC_PATHS = new Set([
  '/login',
  '/register',
  '/register-promo',
  '/complete-account',
  '/complete-setup',
  '/forgot-password',
  '/reset-password',
  '/setup-complete',
  '/checkout-success',
  '/api/auth/callback',
])

const PREFIX_PUBLIC_PATHS = ['/api/auth/callback', '/checkout', '/register']

export function isPublicPathname(pathname: string): boolean {
  if (EXACT_PUBLIC_PATHS.has(pathname)) return true
  return PREFIX_PUBLIC_PATHS.some((prefix) => pathname.startsWith(`${prefix}/`))
}

export function shouldHideHeaderForPathname(pathname: string): boolean {
  if (!pathname) return false
  if (pathname.startsWith('/landing')) return true
  if (pathname.startsWith('/admin')) return true
  if (pathname.startsWith('/school')) return true
  if (pathname.startsWith('/api/auth/')) return true
  if (pathname.startsWith('/checkout/')) return true
  return isPublicPathname(pathname)
}
